export default __webpack_public_path__ + "static/media/IMG-20241210-WA0041.6f7b0d69.jpg";